import { CALL_API } from '../../../middlewares/api';

import {
    REQUEST_EMAIL_VALIDATION_COMMIT,
    SUCCESS_EMAIL_VALIDATION_COMMIT,
    FAILURE_EMAIL_VALIDATION_COMMIT
} from './constants';
import { HTTP_METHOD_POST } from '../../../constants/httpMethod';

/**
 * @param {*} form the form data
 * @param {*} email the email user encoded in base64
 * @param {*} token the token to identify the resetpassword init encoded in base64
 */
export function emailValidationCommit(email, token) {
    return {
        [CALL_API]: {
            endpoint: '/auth/validation-email',
            method: HTTP_METHOD_POST,
            body: { email: email, token: token },
            types: [
                REQUEST_EMAIL_VALIDATION_COMMIT,
                SUCCESS_EMAIL_VALIDATION_COMMIT,
                FAILURE_EMAIL_VALIDATION_COMMIT
            ],
            authenticated: false
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/authentication/emailvalidation/actions.js